import { RouteConfig } from "vue-router";

export const RCandidateTemplateReport: RouteConfig = {
  path: "report/:tabTypeId(\\d+)",
  name: "CandidateTemplateReport",
  component: () =>
    import(
      /* webpackChunkName: "candidate-template-report" */
      "./VTemplateReport.vue"
    ),
  meta: {
    label: "Report",
    tabName: "report",
  },
};

export const RExpertTemplateReport: RouteConfig = {
  path: "report/:tabTypeId(\\d+)",
  name: "ExpertTemplateReport",
  component: () =>
    import(
      /* webpackChunkName: "expert-template-report" */
      "./VTemplateReport.vue"
    ),
  meta: {
    label: "Report",
    tabName: "report",
  },
};
